import React from "react";

export const AccuracyBadge: React.FC<{ accuracy: number | null | undefined }> = ({ accuracy }) => {
  if (accuracy === null || accuracy === undefined) {
    return <span className="al-text-gray-400">-</span>;
  }

  const pct = (accuracy * 100).toFixed(1);
  let colorClass = "al-bg-red-100 al-text-red-700";
  if (accuracy >= 0.8) {
    colorClass = "al-bg-green-100 al-text-green-700";
  } else if (accuracy >= 0.5) {
    colorClass = "al-bg-yellow-100 al-text-yellow-700";
  }

  return (
    <span className={`al-px-2 al-py-1 al-rounded al-text-sm al-font-medium ${colorClass}`}>
      {pct}%
    </span>
  );
};
